import { isImpersonationTab } from "@/lib/auth/impersonation";

/**
 * Where the dashboard keeps what it remembers between loads: `localStorage`,
 * except in an operator's read-only view of a member (task 394), where it is
 * the tab's own `sessionStorage`. The member's selected site, dismissed
 * banners and onboarding progress must not become the operator's own the next
 * time they open their dashboard in that browser.
 *
 * Correct from the first read because `src/boot.ts` settles which kind of tab
 * this is before any store module loads.
 */
export function appStorage(): Storage {
  return isImpersonationTab() ? sessionStorage : localStorage;
}

/**
 * `appStorage()` asked afresh on every access, for zustand's
 * `createJSONStorage`, which takes its storage once when the store is made.
 */
export const tabAwareStorage: Pick<
  Storage,
  "getItem" | "setItem" | "removeItem"
> = {
  getItem: (key) => appStorage().getItem(key),
  setItem: (key, value) => appStorage().setItem(key, value),
  removeItem: (key) => appStorage().removeItem(key),
};
